import { render } from "./EventsListPage.vue?vue&type=template&id=f521f216&ts=true"
import script from "./EventsListPage.vue?vue&type=script&lang=ts"
export * from "./EventsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__